import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        padding: theme.spacing(2, 4),
      },
      content: {
        fontFamily: '"Nunito", snas-serif',
        fontWeight: 300,
        fontSize: 16,
        lineHeight: '22px',
        textAlign: 'left',
        letterSpacing: '0.44px',
        color: sicrediColor.secondarySicrediDarker,
      },
    }),
  {
    name: 'AlertModal',
  }
);
